import React, { useState, useEffect } from 'react'
import { AddressValidation } from '../../utils/Validation'
import { useLocation, useNavigate } from 'react-router-dom'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../utils/PiePage.component'
// import Routes from '../../../../Layout/Routes'
import {
    CommunityLeadSaveUserAddressApi, CommunityLeadGetUserAddressApi,
    CommunityLeadGetUserApi, CommunityLeadGetUserBusinessApi, CommunityLeadGetUserLoanApi,
    getZipBranchDetailApi
} from './AddLeadActionCreator'
import InputField from '../../utils/InputMUI'
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { employmentTypeArr, WEBSITE } from '../../utils/commonFunction'

const AddLeadAddress = ({data,handleTab , handlePage}) => {
    const [objectData, setObjectData] = useState({
        address: "", state: '', city: "", pincode: '',
        addressPerm: '', statePerm: "", cityPerm: '', pincodePerm: '',
        addressComm: '', stateComm: '', cityComm: '', pincodeComm: '',
        addressOrg: '', stateOrg: '', cityOrg: '', pincodeOrg: ''
    })
    const [message, setMessage] = useState({})
    const [loaderState, setLoaderState] = useState(false)
    const [permAddressCheckbox, setPermAddressCheckbox] = useState(false)
    const [commAddressCheckbox, setCommAddressCheckbox] = useState(false)
    const [commPermanentAddressCheckbox, setCommPermanentAddressCheckbox] = useState(false)

    const navigate = useNavigate();
    const location = useLocation();
    const [sourceOfIncome, setsourceOfIncome] = useState('')
    const [loanDetails, setloanDetails] = useState('')
    const [enterCorrectPincode, setenterCorrectPincode] = useState('')
    const [enterCorrectPincodePerm, setenterCorrectPincodePerm] = useState('')

    useEffect(() => {
        if (data !== null && data.rowData !== undefined) {
            getPersonalDetail()
            LoanDetailApi()
        }
    }, [])
    const LoanDetailApi = () => {
        // console.log(location.state.rowData)
        CommunityLeadGetUserLoanApi(data.rowData.loanId, callBack => {
            // console.log(callBack)
            if (callBack.sourceOfIncome) {
                if (data.rowData.sourceOfIncome === undefined) {
                    let changeObjectData = { ...objectData }
                    changeObjectData.sourceOfIncome = callBack.sourceOfIncome
                    getBusinessDetail(changeObjectData)
                }

                setsourceOfIncome(callBack.sourceOfIncome)
                setloanDetails(callBack)

                setLoaderState(false)
            } else {
                setLoaderState(false)

            }
        })
    }

    const getPersonalDetail = () => {
        setLoaderState(true)
        // 
        CommunityLeadGetUserApi(data.rowData.userId,
            callBack => {
                let changeObjectData = { ...objectData }
                changeObjectData.sourceOfIncome = data.rowData.sourceOfIncome
                getBusinessDetail(changeObjectData)
                // setLoaderState(false)

            }, error => {
                // setLoaderState(false)

            })
    }

    const getBusinessDetail = (changeObjectData) => {
        CommunityLeadGetUserBusinessApi(data.rowData.userId,
            callBack => {
                changeObjectData.gstNo = callBack.gstNo
                setAllData(changeObjectData)
            }, error => {

            })
    }

    const setAllData = (changeObjectData) => {
        changeObjectData.userId = data.rowData.userId
        changeObjectData.licenseId = data.rowData.licenseId
        if (data.rowData.loanId !== undefined) {
            changeObjectData.loanId = data.rowData.loanId

        }
        setObjectData(changeObjectData)
        getAddressDetail(changeObjectData)
    }

    const getAddressDetail = (data) => {
        setLoaderState(true)

        CommunityLeadGetUserAddressApi(data.rowData.userId,
            callBack => {
                if (callBack.length > 0) {
                    let changeObjectData = Object.assign({}, data)
                    callBack.forEach(row => {
                        Object.keys(row).forEach(key => {
                            if (key !== 'licenseId') {
                                if (!key.includes('Perm')) {
                                    if (row.addressType === "current") {
                                        changeObjectData[key] = row[key]
                                    }
                                    if (row.addressType === "communication") {
                                        changeObjectData[key + 'Comm'] = row[key]
                                    }
                                    if (row.addressType === "business") {
                                        if (sourceOfIncome == 'salary') {
                                            changeObjectData['addressType' + 'Perm'] = 'permanent'
                                        }
                                        changeObjectData[key + 'Perm'] = row[key]
                                        if (sourceOfIncome == 'salary') {
                                            changeObjectData['addressType' + 'Perm'] = 'permanent'
                                        }
                                    }
                                    if (row.addressType === "permanent") {
                                        changeObjectData[key + 'Perm'] = row[key]
                                    }
                                    if (row.addressType === 'organization') {
                                        changeObjectData[key + 'Org'] = row[key]
                                    }
                                }
                            }
                        })
                    })

                    setObjectData(changeObjectData)
                    setLoaderState(false)

                } else {
                    setLoaderState(false)

                }
            }, error => {
                setLoaderState(false)

            })
    }

    const inputChange = (e, type) => {
        let changeObjectData = Object.assign({}, objectData)
        changeObjectData[type] = e
        if ((type === 'pincodePerm' || type === 'pincode' || type === 'pincodeComm' || type === 'pincodeOrg') && changeObjectData[type].length === 6) {
            const data = {
                code: e,
                type: 'zip'
            }
            setLoaderState(true)
            getZipBranchDetailApi(data, callBack => {

                if (callBack.status === 'success') {
                    setenterCorrectPincode('')
                    let changeObjectData = Object.assign({}, objectData)
                    changeObjectData[type] = e
                    if (type === 'pincode') {
                        changeObjectData.city = callBack.destrict
                        changeObjectData.state = callBack.state
                        if (permAddressCheckbox) {
                            changeObjectData.cityPerm = ''
                            changeObjectData.statePerm = ''
                            changeObjectData.addressPerm = ''
                            changeObjectData.pincodePerm = ''
                            // changeObjectData.addressComm=''
                            changeObjectData.cityComm = ''
                            changeObjectData.stateComm = ''
                            changeObjectData.addressComm = ''
                            changeObjectData.pincodeComm = ''
                            setPermAddressCheckbox(false)
                            setCommAddressCheckbox(false)

                        }
                    }
                    if (type === 'pincodePerm') {
                        setPermAddressCheckbox(false)
                        setenterCorrectPincodePerm('')
                        changeObjectData.cityPerm = callBack.destrict
                        changeObjectData.statePerm = callBack.state
                    }
                    if (type === 'pincodeComm') {
                        setCommAddressCheckbox(false)
                        setCommPermanentAddressCheckbox(false)
                        changeObjectData.cityComm = callBack.destrict
                        changeObjectData.stateComm = callBack.state
                    }
                    if (type === 'pincodeOrg') {

                        changeObjectData.cityOrg = callBack.destrict
                        changeObjectData.stateOrg = callBack.state
                    }
                    setLoaderState(false)

                    setObjectData(changeObjectData)
                } else {
                    if (type === 'pincode') {
                        setenterCorrectPincode('Please enter correct pincode')
                        changeObjectData.pincode = ''
                        changeObjectData.city = ''
                        changeObjectData.state = ''
                    }
                    if (type === 'pincodePerm') {
                        setenterCorrectPincodePerm('Please enter correct pincode')
                        changeObjectData.pincodePerm = ''
                        changeObjectData.cityPerm = ''
                        changeObjectData.statePerm = ''
                    }
                    if (type === 'pincodeComm') {
                        // setenterCorrectPincodePerm('Please enter correct pincode')
                        changeObjectData.pincodeComm = ''
                        changeObjectData.cityComm = ''
                        changeObjectData.stateComm = ''

                    }
                    setLoaderState(false)
                    // alert('Please enter correct pincode')
                }
            }, error => {

            })
        } else {

            if (e === '' && type === 'pincode') {
                changeObjectData.pincode = ''
                changeObjectData.city = ''
                changeObjectData.state = ''
                setObjectData(changeObjectData)

            }
            if (e === '' && type === 'pincodePerm') {
                changeObjectData.pincodePerm = ''
                changeObjectData.cityPerm = ''
                changeObjectData.statePerm = ''
                setObjectData(changeObjectData)
                // setPermAddressCheckbox(false)


            }
            if (e === '' && type === 'pincodeComm') {
                changeObjectData.pincodeComm = ''
                changeObjectData.cityComm = ''
                changeObjectData.stateComm = ''
                setObjectData(changeObjectData)
                // setPermAddressCheckbox(false)
                setCommAddressCheckbox(false)
                setCommPermanentAddressCheckbox(false)

            }

        }
        setObjectData(changeObjectData)
        setMessage({})
        checkpermanentaddressChckbox()
    }
    const checkpermanentaddressChckbox = () => {
        if (objectData.pincode !== objectData.pincodePerm) {
            setPermAddressCheckbox(false)

        }
    }


    const saveHandler = (e) => {
        if (e === 'save') {
            let validationMsg = AddressValidation(objectData)
            if (validationMsg.status) {
                setMessage(validationMsg)
                // if (enterCorrectPincodePerm === '' && enterCorrectPincode === '') {
                setLoaderState(true)

                CommunityLeadSaveUserAddressApi(objectData,
                    callBack => {
                        if (data.rowData.loanId !== undefined) {
                            callBack[0].loanId = data.rowData.loanId
                        }
                        if (data.rowData.gstNo !== undefined) {
                            callBack[0].gstNo = data.rowData.gstNo
                        }
                        if (!window.location.href.includes("/external")) {
                            const obj= { 
                                rowData: (callBack.length > 0 ? callBack[0] : callBack ),
                                 communityId: data ? data.communityId : null,
                                  qrId : data ? data.qrId : null 
                                }
                                handleTab("addLeadLoan",obj)

                            // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_LOAN : Routes.COMMUNITY_ADD_LEAD_LOAN, { 
                            //     state: { rowData: (callBack.length > 0 ? callBack[0] : callBack ), communityId: data ? data.communityId : null, qrId : data ? data.qrId : null } })
                        }
                      
                        setLoaderState(false)
                    },
                    error => {
                        setLoaderState(false)
                    })
                // }
            } else {
                setMessage(validationMsg)
            }
        } else if (e === 'close') {
            // if (location.state ? location.state.communityId : null) {
            //     let data = location.state.rowData
            //     data.communityId = location.state ? location.state.communityId : null
            //     navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: data, page: 'communityLeads' } })
            // }  else if (location.state ? location.state.qrId : null) {
            //     let data = location.state.rowData
            //     data.qrId = location.state ? location.state.qrId : null
            //     navigate(Routes.SUPER_ADMIN_QR_DETAILS, { state: { rowData: data, page: 'leads' } })
            // } else
            //     navigate(window.location.href.includes('admin') ? Routes.SUPER_ADMIN_ALL_LEADS : Routes.COMMUNITY_ALL_LEADS)
            handlePage("","list")
        } else if (e === 'back') {


            if (!window.location.href.includes('/external')) {
                const obj = { rowData: loanDetails, communityId: data ? data.communityId : null  }
                if (sourceOfIncome === "businessprofessionalincome") {
                    handleTab("addLeadDirector",obj)
                    // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_DIRECTOR : Routes.COMMUNITY_ADD_LEAD_DIRECTOR, { state: { rowData: loanDetails, communityId: location.state ? location.state.communityId : null  } })
                } else if (sourceOfIncome === 'salary') {
                    handleTab("addLeadSalariedDetails",obj)
                    // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_SALARIED : Routes.COMMUNITY_ADD_LEAD_SALARIED, { state: { rowData: loanDetails, communityId: location.state ? location.state.communityId : null } })
                } else if (sourceOfIncome !== "businessprofessionalincome" && sourceOfIncome !== 'salary') {
                    handleTab("addLeadProperty",obj)
                    // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_PROPERTY : Routes.COMMUNITY_ADD_LEAD_PROPERTY, { state: { rowData: loanDetails , communityId: location.state ? location.state.communityId : null} })
                }
            } 

        }
    }

    const handleChechbox = (e, type) => {
        let changeObjectData = Object.assign({}, objectData)
        if (type === 'perm') {
            setPermAddressCheckbox(e.target.checked)
            if (e.target.checked) {
                changeObjectData['addressPerm'] = changeObjectData['address']
                changeObjectData['statePerm'] = changeObjectData['state']
                changeObjectData['cityPerm'] = changeObjectData['city']
                changeObjectData['pincodePerm'] = changeObjectData['pincode']
            } else {
                changeObjectData['addressPerm'] = ''
                changeObjectData['statePerm'] = ''
                changeObjectData['cityPerm'] = ''
                changeObjectData['pincodePerm'] = ''
            }
        } else if (type === 'comm') {
            setCommPermanentAddressCheckbox(false)

            setCommAddressCheckbox(e.target.checked)
            if (e.target.checked) {
                changeObjectData['addressComm'] = changeObjectData['address']
                changeObjectData['stateComm'] = changeObjectData['state']
                changeObjectData['cityComm'] = changeObjectData['city']
                changeObjectData['pincodeComm'] = changeObjectData['pincode']
            } else {
                changeObjectData['addressComm'] = ''
                changeObjectData['stateComm'] = ''
                changeObjectData['cityComm'] = ''
                changeObjectData['pincodeComm'] = ''
            }
        } else if (type === 'CommPerm') {
            setCommPermanentAddressCheckbox(e.target.checked)
            setCommAddressCheckbox(false)

            if (e.target.checked) {
                changeObjectData['addressComm'] = changeObjectData['addressPerm']
                changeObjectData['stateComm'] = changeObjectData['statePerm']
                changeObjectData['cityComm'] = changeObjectData['cityPerm']
                changeObjectData['pincodeComm'] = changeObjectData['pincodePerm']
            } else {
                changeObjectData['addressComm'] = ''
                changeObjectData['stateComm'] = ''
                changeObjectData['cityComm'] = ''
                changeObjectData['pincodeComm'] = ''
            }
        }
        setObjectData(changeObjectData)
        setMessage({})
    }

    return (
        <div className='container hoverNone card'>
            {loaderState ?
                <Loader />
                : null}
            {/* {console.log(loanDetails, 'loanDetails')} */}
            <PiePage
                totalPage={6}
                currentPage={3}
                heading={'Add Address Info'}
            />
            <h6 style={{ textDecoration: 'underline', textTransform: 'uppercase', fontWeight: '700' }}>{sourceOfIncome === employmentTypeArr[0].code ? 'Business Address' : 'Current Address'}</h6>
            <div className='row' style={{marginBottom:'12px'}}>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="Address"
                        variant="outlined"
                        value={objectData.address}
                        name="address"
                        id="address"
                        type="text"
                        onChange={e => inputChange(e, 'address')}
                        size="small"
                    // required={true}
                    />
                    <div id="addressHelp" className="form-text text-danger">{message.field === 'address' ? message.msg : ""}</div>
                </div>
                <div className=' col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="Pincode"
                        variant="outlined"
                        value={objectData.pincode}
                        name="pincode"
                        id="pincode"
                        type="number"
                        onChange={e => inputChange(e, 'pincode')}
                        size="small"
                    // required={true}
                    />
                    <div className="form-text text-danger"> {enterCorrectPincode}</div>

                    <div id="pincodeHelp" className="form-text text-danger">{message.field === 'pincode' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="State"
                        variant="outlined"
                        value={objectData.state}
                        name="state"
                        id="state"
                        type="text"
                        onChange={e => inputChange(e, 'state')}
                        size="small"
                        readOnly={true}
                    // required={true}
                    />
                    <div id="stateHelp" className="form-text text-danger">{message.field === 'state' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="City"
                        variant="outlined"
                        value={objectData.city}
                        name="city"
                        id="city"
                        type="text"
                        onChange={e => inputChange(e, 'city')}
                        size="small"
                        readOnly={true}
                    // required={true}
                    />
                    <div id="cityHelp" className="form-text text-danger">{message.field === 'city' ? message.msg : ""}</div>
                </div>
            </div>
            <h6 className='' style={{marginBottom:'12px'}}>
                <span style={{ textDecoration: 'underline', textTransform: 'uppercase', fontWeight: '700' }}>{sourceOfIncome ? sourceOfIncome === 'businessprofessionalincome' ? 'Aadhaar Address' : 'Permanent Address' : ""}</span>
                &nbsp;&nbsp;&nbsp;
                <FormControlLabel
                    label={"Same as " + (sourceOfIncome ? sourceOfIncome === 'businessprofessionalincome' ? 'Business Address' : "current address" : "")}
                    control={<Checkbox checked={permAddressCheckbox} onChange={e => handleChechbox(e, 'perm')} />}
                />
            </h6>
            <div className='row' style={{marginBottom:'12px'}}>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="Address"
                        variant="outlined"
                        value={objectData.addressPerm}
                        name="addressPerm"
                        id="addressPerm"
                        type="text"
                        onChange={e => inputChange(e, 'addressPerm')}
                        size="small"
                        // required={true}
                        readOnly={permAddressCheckbox}
                    />
                    <div id="addressPermHelp" className="form-text text-danger">{message.field === 'addressPerm' ? message.msg : ""}</div>
                </div>
                <div className=' col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="Pincode"
                        variant="outlined"
                        value={objectData.pincodePerm}
                        name="pincodePerm"
                        id="pincodePerm"
                        type="number"
                        onChange={e => inputChange(e, 'pincodePerm')}
                        size="small"
                        // required={true}
                        readOnly={permAddressCheckbox}

                    />
                    <div className="form-text text-danger"> {enterCorrectPincodePerm}</div>
                    <div id="pincodePermHelp" className="form-text text-danger">{message.field === 'pincodePerm' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="State"
                        variant="outlined"
                        value={objectData.statePerm}
                        name="statePerm"
                        id="statePerm"
                        type="text"
                        onChange={e => inputChange(e, 'statePerm')}
                        size="small"
                        readOnly={true}
                    // required={true}
                    />
                    <div id="statePermHelp" className="form-text text-danger">{message.field === 'statePerm' ? message.msg : ""}</div>
                </div>
                <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                    <InputField
                        label="City"
                        variant="outlined"
                        value={objectData.cityPerm}
                        name="cityPerm"
                        id="cityPerm"
                        type="text"
                        onChange={e => inputChange(e, 'cityPerm')}
                        size="small"
                        readOnly={true}
                    // required={true}
                    />
                    <div id="cityPermHelp" className="form-text text-danger">{message.field === 'cityPerm' ? message.msg : ""}</div>
                </div>
            </div>
            {objectData.gstNo !== null && objectData.gstNo !== undefined && objectData.gstNo !== '' ?
                <>
                    <h6 className='' style={{marginBottom:'12px'}}>
                        <span style={{ textDecoration: 'underline', textTransform: 'uppercase', fontWeight: '700' }}>Communication Address</span>
                        &nbsp;&nbsp;&nbsp;
                        <FormControlLabel
                            label={"Same as " + (objectData.sourceOfIncome === employmentTypeArr[0].code ? 'Business Address' : "current address")}
                            control={<Checkbox checked={commAddressCheckbox} onChange={e => handleChechbox(e, 'comm')} />}
                        />
                        <FormControlLabel
                            label={"Same as " + (objectData.sourceOfIncome === employmentTypeArr[0].code ? 'Aadhar Address' : "Permanent address")}
                            control={<Checkbox checked={commPermanentAddressCheckbox} onChange={e => handleChechbox(e, 'CommPerm')} />}
                        />
                    </h6>
                    <div className='row' style={{marginBottom:'12px'}}>
                        <div className=' col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                            <InputField
                                label="Address"
                                variant="outlined"
                                value={objectData.addressComm}
                                name="addressComm"
                                id="addressComm"
                                type="text"
                                onChange={e => inputChange(e, 'addressComm')}
                                size="small"
                            // required={true}
                            />
                            <div id="addressCommHelp" className="form-text text-danger">{message.field === 'addressComm' ? message.msg : ""}</div>
                        </div>
                        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                            <InputField
                                label="Pincode"
                                variant="outlined"
                                value={objectData.pincodeComm}
                                name="pincodeComm"
                                id="pincodeComm"
                                type="number"
                                onChange={e => inputChange(e, 'pincodeComm')}
                                size="small"
                            // required={true}
                            />
                            <div id="pincodeCommHelp" className="form-text text-danger">{message.field === 'pincodeComm' ? message.msg : ""}</div>
                        </div>
                        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                            <InputField
                                label="State"
                                variant="outlined"
                                value={objectData.stateComm}
                                name="stateComm"
                                id="stateComm"
                                type="text"
                                onChange={e => inputChange(e, 'stateComm')}
                                size="small"
                                readOnly={true}
                            // required={true}
                            />
                            <div id="stateCommHelp" className="form-text text-danger">{message.field === 'stateComm' ? message.msg : ""}</div>
                        </div>
                        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}> 
                            <InputField
                                label="City"
                                variant="outlined"
                                value={objectData.cityComm}
                                name="cityComm"
                                id="cityComm"
                                type="text"
                                onChange={e => inputChange(e, 'cityComm')}
                                size="small"
                                readOnly={true}
                            // required={true}
                            />
                            <div id="cityCommHelp" className="form-text text-danger">{message.field === 'cityComm' ? message.msg : ""}</div>
                        </div>
                    </div>
                </>
                : null}
            {sourceOfIncome === 'salary' ?
                <>
                    <h6 className='' style={{marginBottom:'12px'}}>
                        <span style={{ textDecoration: 'underline', textTransform: 'uppercase', fontWeight: '700' }}>Organisation Address</span>
                        &nbsp;&nbsp;&nbsp;

                    </h6>
                    <div className='row' style={{marginBottom:'12px'}}>
                        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                            <InputField
                                label="Address"
                                variant="outlined"
                                value={objectData.addressOrg}
                                name="addressOrg"
                                id="addressOrg"
                                type="text"
                                onChange={e => inputChange(e, 'addressOrg')}
                                size="small"
                            // required={true}
                            />
                            <div id="addressOrgHelp" className="form-text text-danger">{message.field === 'addressOrg' ? message.msg : ""}</div>
                        </div>
                        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                            <InputField
                                label="Pincode"
                                variant="outlined"
                                value={objectData.pincodeOrg}
                                name="pincodeOrg"
                                id="pincodeOrg"
                                type="number"
                                onChange={e => inputChange(e, 'pincodeOrg')}
                                size="small"
                            // required={true}
                            />
                            <div id="pincodeOrgHelp" className="form-text text-danger">{message.field === 'pincodeOrg' ? message.msg : ""}</div>
                        </div>
                        <div className=' col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                            <InputField
                                label="State"
                                variant="outlined"
                                value={objectData.stateOrg}
                                name="stateOrg"
                                id="stateOrg"
                                type="text"
                                onChange={e => inputChange(e, 'stateOrg')}
                                size="small"
                                readOnly={true}
                            // required={true}
                            />
                            <div id="stateOrgHelp" className="form-text text-danger">{message.field === 'stateOrg' ? message.msg : ""}</div>
                        </div>
                        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
                            <InputField
                                label="City"
                                variant="outlined"
                                value={objectData.cityOrg}
                                name="cityOrg"
                                id="cityOrg"
                                type="text"
                                onChange={e => inputChange(e, 'cityOrg')}
                                size="small"
                                readOnly={true}
                            // required={true}
                            />
                            <div id="cityOrgHelp" className="form-text text-danger">{message.field === 'cityOrg' ? message.msg : ""}</div>
                        </div>
                    </div>
                </>
                : null}
            <div className='row' style={{marginBottom:'12px'}}>
                <div className="col-12 text-center">
                    {
                        !window.location.href.includes('/external') ?
                            <button className="cred-btn cancel-btn" onClick={e => saveHandler('close')}>Close</button>
                            :
                            <a href={WEBSITE}> <button type="button" className="cred-btn">Close</button></a>
                    }
                    <button className="cred-btn cancel-btn" onClick={e => saveHandler('back')}>Back</button>
                    <button className="cred-btn" onClick={e => saveHandler('save')}>Save and Continue</button>
                </div>
            </div>
        </div>
    )
}

export default AddLeadAddress;